import React from 'react';
import {observer,inject} from 'mobx-react';
import App from './App';
import 'moment/locale/zh-cn';

@inject('rootStore')
@observer
export default class Main extends React.Component{
    componentDidMount() {
        this.props.rootStore.localeStore.loadLocales();
    }

    render(){

        return (
            this.props.rootStore.localeStore.initDone ?
                <React.Fragment>
                    <App/>
                </React.Fragment>
            :null
        )

    }
}


// WEBPACK FOOTER //
// ./src/main.js